import { Capacitor } from '@capacitor/core';

/** Native runtime eligibility is independent of remotely configured logging levels. */
export function isNativeDiagnosticsSupported(): boolean {
  try {
    if (!Capacitor.isNativePlatform()) return false;
    const platform = Capacitor.getPlatform();
    return platform === 'ios' || platform === 'android';
  } catch {
    return false;
  }
}

/** Diagnostics supplies additional admission; database services know no payment state. */
export type DiagnosticAdmission = () => boolean;

export class DiagnosticIODeferred extends Error {
  constructor() {
    super('Diagnostic I/O deferred');
    this.name = 'DiagnosticIODeferred';
  }
}

export function assertDiagnosticAdmission(admit: DiagnosticAdmission): void {
  if (!isNativeDiagnosticsSupported() || !admit()) throw new DiagnosticIODeferred();
}
